import React from "react"

import type { Background } from "@/lib/background"
import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"

export const BackgroundContext = React.createContext<Background.ContextData>({
  subscribeToBackgroundClicks: () => {
    return contextPlaceholderFunction
  },
})
